import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a109f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_project" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "标题：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "订单号：", -1))
const _hoisted_9 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("导出excel")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "my-header" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加", -1))
const _hoisted_44 = { class: "my-header" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1))

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import { requestWeekTj } from '@/api/xmApi';
	import { ElMessage } from 'element-plus';
	import Excel from '@/components/Excel'
	
export default /*#__PURE__*/_defineComponent({
  name: 'projectweekstatuslist',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref([])
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		title:'', 
		ordernumber:''
	})//搜索
	const DDDepartlist= ref([])
	const addShow = ref(false)
	const userShow = ref(false)
	const exceladdShow = ref<boolean>(false)
	const excelShow= ref<boolean>(false)
	const uuid = ref("")
	const dddepartid=ref("")
	onMounted(()=>{
		getWeekTj();
	})
	const getWeekTj = (val: number) =>{
		loading.value = true
		requestWeekTj({
			title:search.value.title,
			ordernumber:search.value.ordernumber,
			dcexcel:val
		}).then((res:any)=>{
			tableData.value = res.datalist
			loading.value = false
			if(val==1){
				window.open(res.msg)
			}
		})
	}
	
	//提交成功后
	const cancel = (val: any) => {
		addShow.value = false
		if(val){
			getWeekTj();
		}
	}
	
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getWeekTj();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getWeekTj();
	}
	const searchList = (val: number) =>{
		pageIndex.value = 1
		getWeekTj(val);
	}

	
	const excelsx = () =>{
		excelShow.value = false
		nextTick(()=>{
			excelShow.value = true
		})
	}
	const excelcancel = () => {
		exceladdShow.value = false
		getWeekTj();
	}
	const exceladd = ()=>{
		excelsx();
		exceladdShow.value = true
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.title) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList(0)), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.ordernumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.ordernumber) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchList(0)), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (searchList(0))),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (searchList(1))),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["icon"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: _ctx.details,
      "empty-text": "暂无数据",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
      height: "600",
      "header-fixed": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "70",
          fixed: "left",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "allstartdate",
          fixed: "left",
          label: "投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          fixed: "left",
          label: "标题",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "ordernumber",
          fixed: "left",
          label: "订单号",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "squarenumber",
          fixed: "left",
          label: "平方数",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate1",
          label: "板投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate1",
          label: "板完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate1=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate1), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate1!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scope.row.plenddate1), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate1",
          label: "板实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate1yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate1), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate1yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(scope.row.grenddate1), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate1",
          label: "板验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate1yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate1), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate1yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(scope.row.acenddate1), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate2",
          label: "料投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate2",
          label: "料完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate2=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate2), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate2!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(scope.row.plenddate2), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate2",
          label: "料实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate2yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate2), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate2yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(scope.row.grenddate2), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate2",
          label: "料验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate2yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate2), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate2yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(scope.row.acenddate2), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate3",
          label: "零件油漆投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate3",
          label: "零件油漆完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate3=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate3), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate3!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(scope.row.plenddate3), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate3",
          label: "零件油漆实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate3yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate3), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate3yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(scope.row.grenddate3), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate3",
          label: "零件油漆验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate3yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate3), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate3yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(scope.row.acenddate3), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate4",
          label: "组装-墙投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate4",
          label: "组装-墙完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate4=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate4), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate4!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(scope.row.plenddate4), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate4",
          label: "组装-墙实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate4yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate4), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate4yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(scope.row.grenddate4), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate4",
          label: "组装-墙验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate4yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate4), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate4yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(scope.row.acenddate4), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate5",
          label: "组装-门投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate5",
          label: "组装-门完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate5=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate5), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate5!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(scope.row.plenddate5), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate5",
          label: "组装-门实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate5yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate5), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate5yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(scope.row.grenddate5), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate5",
          label: "组装-门验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate5yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate5), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate5yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(scope.row.acenddate5), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate6",
          label: "组装-柜投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate6",
          label: "组装-柜完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate6=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate6), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate6!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(scope.row.plenddate6), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate6",
          label: "组装-柜实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate6yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate6), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate6yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(scope.row.grenddate6), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate6",
          label: "组装-柜验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate6yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate6), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate6yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(scope.row.acenddate6), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate7",
          label: "二楼底漆/修复投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate7",
          label: "二楼底漆/修复完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate7=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate7), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate7!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(scope.row.plenddate7), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate7",
          label: "二楼底漆/修复实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate7yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate7), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate7yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(scope.row.grenddate7), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate7",
          label: "二楼底漆/修复验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate7yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate7), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate7yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(scope.row.acenddate7), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate8",
          label: "五楼底漆投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate8",
          label: "五楼底漆完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate8=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate8), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate8!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(scope.row.plenddate8), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate8",
          label: "五楼底漆实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate8yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate8), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate8yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(scope.row.grenddate8), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate8",
          label: "五楼底漆验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate8yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate8), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate8yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(scope.row.acenddate8), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate9",
          label: "四楼面漆投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate9",
          label: "四楼面漆完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate9=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate9), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate9!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(scope.row.plenddate9), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate9",
          label: "四楼面漆实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate9yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate9), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate9yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(scope.row.grenddate9), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate9",
          label: "四楼面漆验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate9yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate9), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate9yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(scope.row.acenddate9), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "startdate10",
          label: "安包投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plenddate10",
          label: "安包完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.plenddate10=='可投产')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.plenddate10), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.plenddate10!='可投产')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(scope.row.plenddate10), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "grenddate10",
          label: "安包实际完成时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.grenddate10yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.grenddate10), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.grenddate10yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(scope.row.grenddate10), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "acenddate10",
          label: "安包验收时间",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.acenddate10yq=='逾期')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.acenddate10), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (scope.row.acenddate10yq!='逾期')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(scope.row.acenddate10), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onCellClick", "data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (addShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (userShow.value)
          ? (_openBlock(), _createBlock(AddUser, {
              key: 0,
              onCancel: cancel,
              uuid: uuid.value
            }, null, 8, ["uuid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Excel导入",
      modelValue: exceladdShow.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((exceladdShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (exceladdShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow.value)
          ? (_openBlock(), _createBlock(_unref(Excel), {
              key: 0,
              onCancel: _cache[9] || (_cache[9] = ($event: any) => (excelcancel())),
              id: "用户导入"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})